import { RoleApi } from 'api-typings/grants/grants';
import { SuperuserRole } from './superuser-roles.model';

export function transformSuperuserRole(role: RoleApi): SuperuserRole {
  return {
    id: role.id,
    name: role.name,
    grantedPermissions: role.granted_permissions,
  };
}
